const isAxiosTimeout = error =>
  typeof error === "object" &&
  error !== null &&
  error instanceof Error &&
  error.code === "ECONNABORTED";

export default isAxiosTimeout;
